import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody27.css';

import clientimg from '../images/case-study-client27.webp'
import outcome from '../images/outcome27.webp'

import sm1 from '../images/cs27so1.webp'
import sm2 from '../images/cs27so2.webp'
import sm3 from '../images/cs27so3.webp'
import sm4 from '../images/cs27so4.webp'



const Casestudybody27 = () => {

    return (
        <>
        <section className='casestudybody27-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A multi-billion-dollar single family-office established with an intent to own, preserve, invest and manage a diverse global real estate portfolio and private equity holdings</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client wanted to cascade its long-term strategy into annual plans and allocate appropriate budgets accordingly</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody27-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                  
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Kick-off Meeting:</h4>
                          <p>Kick-off meeting was conducted with the CEO, Strategy Director, the CFO to establish consensus on the overall <span style={{color:"#01C6B2"}}>framework and establish objective</span> or <span style={{color:"#01C6B2"}}>unifying theme for the annual operating plan</span></p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Onsite Workshops:</h4>
                          <p>An <span style={{color:"#01C6B2"}}>onsite workshop was conducted with all departmental heads</span> to understand their ongoing & projects in pipeline in which the department would indulge into. Synthesized their inputs and funding requirements for capital expenditures, divestment initiatives, estimated capability requirements & associates costs, while ensuring data cohesiveness and accuracy</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Report Compilation:</h4>
                          <p>Structured the collated inputs and identified the major annual projects & activities planned by each department and created a <span style={{color:"#01C6B2"}}>comprehensive overview of the firm's strategic initiatives</span> (obtain endorsement from the CEO & CFO)</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Budgeting:</h4>
                          <p>Collaborated with the CFO or finance department to define the <span style={{color:"#01C6B2"}}>optimal funding source</span> for the identified activities across the organization</p>
                        </div>
                      </div>                 

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>KPI Identification:</h4>
                          <p>Mapped & cascaded the identified activities to <span style={{color:"#01C6B2"}}>departmental Key Performance Indicators, established the clear timelines and budgetary targets</span> for effective performance management and tracking</p>
                        </div>
                      </div> 
                     
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody27-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A structured planning exercise provided strategic clarity by aligning annual departmental initiatives with long-term objectives, enabling the client to allocate resources effectively, track performance through KPIs, and drive data-informed decision-making across the organization</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody27
